module.exports = __webpack_public_path__ + "static/media/product-image-2-view.65d9901c.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/components/howToFeature/product-image-2-view.png
// module id = 268
// module chunks = 0